import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import { DivProps } from 'commons/types/htmlElements'
import { ReactNode } from 'react'
import { css } from '@mui/styled-engine'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
`

interface BatchIconProps {
  disabled: boolean
}

export const BatchIconStyled = styled.span<BatchIconProps>`
  display: flex;
  :hover {
    fill: ${theme.colors.primary.hover};
    cursor: pointer;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      svg {
        path {
          fill: ${theme.colors.neutral.mediumhover};
        }
      }

      pointer-events: none;
    `}
`

interface BatchAreaProps {
  hasLabel: boolean
  height: number
}

export const WrapperBatchArea = styled.div<BatchAreaProps>`
  background-color: ${theme.colors.neutral.white};
  position: absolute;
  min-width: 200px;
  width: 100%;
  z-index: 1000;
  top: ${({ height, hasLabel }) => (hasLabel ? `${height + 17}px` : `${height}px`)};
  left: 0;
  box-shadow: 0px 0px 6px rgba(92, 92, 92, 0.102);
  border-radius: ${theme.shapes.borderRadius.sm};
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: visible;
`
export const BatchArea = styled.div`
  margin: ${theme.spacing.sm};
  width: calc(100% - ${theme.spacing.xm});
`
interface WrapIconStyledProps extends DivProps {
  disabled?: boolean
  content?: string | ReactNode
}
export const WrapIconStyled = styled.button<WrapIconStyledProps>`
  display: flex;
  background-color: unset;
  border: none;
  & svg,
  svg path {
    fill: ${({ disabled }) =>
      disabled ? theme.colors.neutral.clear : theme.colors.primary.main};
  }
  ${({ content }) =>
    content &&
    `
        svg {
          margin: initial;
          font-size: ${theme.icon.size.small};
          margin-right: ${theme.spacing.xs};
        }
      `}

  ${({ disabled }) =>
    css`
      :hover {
        & svg,
        svg path {
          fill: ${disabled ? theme.colors.neutral.clear : theme.colors.primary.hover};
        }
        cursor: ${disabled ? 'not-allowed' : 'pointer'};
      }
    `}
`

export const WrapperButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  margin-top: ${theme.spacing.sm};
  gap: ${theme.spacing.xs};
`
